"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendStatusDropdown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const STATE_DROPDOWN_LIST = [
    { id: 'select', title: 'sendSMS.sendStatus' },
    { id: 'created', title: 'sendSMS.reservation' },
    { id: 'sent', title: 'sendSMS.sent' },
    { id: 'failed', title: 'sendSMS.failed' },
];
exports.SendStatusDropdown = react_1.default.memo(({ sendStatus, setSendStatus }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState({
        id: 'select',
        title: 'sendSMS.sendStatus',
    });
    react_1.default.useEffect(() => {
        if (sendStatus !== value.id)
            setValue(STATE_DROPDOWN_LIST.find(item => item.id === sendStatus));
    }, [sendStatus]);
    const handlerUpdateDrop = (item) => {
        setSendStatus(item.id);
        setValue(item);
    };
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: value, list: STATE_DROPDOWN_LIST, styles: {
            ...(isMobile ? {} : { dropWrap: { width: isTablet ? 100 : 150 } }),
            itemWrap: {
                top: isTablet ? '50px' : '45px',
            },
        }, setDropValue: handlerUpdateDrop }));
});
